module.exports = __webpack_public_path__ + "media/images/landing-pages/stem_course-1f00da182af833d6e50b5a47e5a79032.png";